module.exports = __webpack_public_path__ + "img/calculator-bg-spotify.7e077426.svg";